<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="todos"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="todo"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :todo="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="totalTodos"
        @current-change="handlePagination"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
      };
    },
    computed: {
      todos() {
        return this.$store.getters['todo/todos'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['todo/tableConfig']));
      },
      loading() {
        return this.$store.getters['todo/loading'];
      },
      currentPage() {
        return this.$store.state.todo.currentPage;
      },
      totalTodos() {
        return this.$store.state.todo.totalTodos;
      },
      pageSize() {
        return this.$store.state.todo.pageSize;
      },
    },
    methods: {
      handlePagination (newPage) {
        this.$store.commit('todo/setCurrentPage', newPage)
        this.$store.dispatch('todo/fetchAll')
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('todo/setSorting', {prop, order});
          this.$store.commit('todo/setCurrentPage', 1)
          this.$store.dispatch('todo/fetchAll');
        }
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      await this.$store.dispatch('todo/fetchAll');
    },
  };
</script>
